import React, { useState, useEffect } from 'react'
import { useIntl, FormattedMessage, FormattedDate } from 'react-intl'
import messages from 'i18n/messages'
import isEmpty from 'lodash/isEmpty'
import { useSelector, useDispatch } from 'react-redux'
import { Row, Col, Spinner, Button, Form, FormGroup, Label, FormText, Input } from 'reactstrap'
import { makeSelectDateById, fetchDateById } from 'logic/dates'
import { makeSelectCurOrg } from 'logic/orgs'
import { defaultDateFormat } from '../lib/misc'
import { updateCustomerAttr, makeSelectCustomer } from 'logic/customers'
import { setStepOneComplete, setManualSeatInfos, makeSelectStepOneComplete } from 'logic/goods'
import { GoodsBasket, FormItem} from '../components'

export default function GoodsContactForm () {
  const dispatch = useDispatch()
  const customer = useSelector(makeSelectCustomer())
  const handleChange = (key, value) =>
    dispatch(updateCustomerAttr(key, value))

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(updateCustomerAttr('ready', true))
  }

  return (
    <div className="tt-book-settings tickets-selection">
      <GoodsBasket />
      <div className="p-4">
        <h4>
          <FormattedMessage {...messages.contactData} />
        </h4>
        <Form className="p-4" onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem
                name="firstname"
                onChange={handleChange}
                obj={customer}
                validationError="please enter a value"
              />
            </Col>
            <Col xs={12} sm={6}>
              <FormItem name="lastname" onChange={handleChange} obj={customer} required />
            </Col>
          </Row>
          <Row>
            <Col lg={7}>
              <FormItem name="email" onChange={handleChange} obj={customer} required />
            </Col>
            <Col lg={5}>
              <FormItem name="phone" onChange={handleChange} obj={customer} />
            </Col>
          </Row>
          <p>
            <FormText>
              <FormattedMessage {...messages.explainRequiredFields} values={{ sup: (...chunks) => <sup key="ttt">{chunks}</sup> }} />
            </FormText>
          </p>
          
          <div className="d-flex justify-content-center">
            <Button size="lg" type="submit" color="primary">
              <FormattedMessage {...messages.continue} />
            </Button>
          </div>
        </Form>
      </div>
    </div>
  )
}